




import { Vue, Component } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 分页
import EditRole from '@/views/system/permission/role/unit/editRole.vue';
import RoleAssignDataPermissions from '@/views/system/permission/role/unit/roleAssignDataPermissions.vue';
import RoleAssignFunctionalPermissions from '@/views/system/permission/role/unit/roleAssignFunctionalPermissions.vue';
import RoleAssignmentUser from '@/views/system/permission/role/unit/roleAssignmentUser/roleAssignmentUser.vue';
import addRole from '@/views/system/permission/role/unit/addRole.vue';
import Role from '@/views/system/permission/role/unit/role.vue'; // 导入主页

@Component({
  components: {
    PagingUnit,
    RoleAssignFunctionalPermissions,
    EditRole,
    RoleAssignDataPermissions,
    RoleAssignmentUser,
    addRole,
    Role,
  },
})
export default class RoleIndex extends Vue {}
